export default __webpack_public_path__ + "static/media/image8.fc3ea7ae.png";